"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkboxWrapper = exports.checkboxOn = exports.checkboxMixed = void 0;
var _styledComponents = require("styled-components");
const checkboxWrapper = (0, _styledComponents.css)`
    width: 17px;
    height: 17px;

    display: inline-flex;
    vertical-align: top;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    background-color: var(--bg-color, var(--color-bg), white);
    border: 1px solid var(--text-primary-color, var(--color-text-prim, white));
    border-radius: 3px;

    cursor: pointer;

    flex-shrink: 0;
`;
exports.checkboxWrapper = checkboxWrapper;
const checkboxOn = (0, _styledComponents.css)`
    font-family: 'icomoon';
    content: var(--icon-check);
    color: var(--text-primary-color, var(--color-text-prim, grey));
    font-size: 15px;
`;
exports.checkboxOn = checkboxOn;
const checkboxMixed = (0, _styledComponents.css)`
    content: ' ';
    width: 9px;
    height: 9px;

    box-sizing: border-box;
    background-color: var(--text-primary-color, var(--color-text-prim, grey));
    border-radius: 1px;
    opacity: 0.6;
`;
exports.checkboxMixed = checkboxMixed;